module.exports = __webpack_public_path__ + "media/application/images/2025/title-2000-be1b039718d682a5841d5f8e39d45520.png";